import { render, staticRenderFns } from "./brandKit.vue?vue&type=template&id=5db006fc"
import script from "./brandKit.vue?vue&type=script&lang=js"
export * from "./brandKit.vue?vue&type=script&lang=js"
import style0 from "./brandKit.vue?vue&type=style&index=0&id=5db006fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports